module.exports = __webpack_public_path__ + "static/b627f748b9334fe476d39f1ccd5cf1e92a00503449a5285d4f4b2088bcddc16a-0a8e99377c1c16cc4f5b30b76cdbff24.png";